import m from "../../geodata/es2015/anguillaLow";
window.am4geodata_anguillaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/anguillaLow.js
// module id = null
// module chunks = 